import type { RouteObject } from "react-router-dom";
import Gracias from "../pages/gracias/page";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Persianas from "../pages/persianas/page";
import PersianasElectricas from "../pages/persianas/persianas-electricas/page";
import CambiarCinta from "../pages/persianas/cambiar-cinta-persiana/page";
import PersianasAluminio from "../pages/persianas/persianas-aluminio/page";
import PersianasPVC from "../pages/persianas/persianas-pvc/page";
import PreciosPersianas from "../pages/persianas/precios-persianas/page";
import Toldos from "../pages/toldos/page";
import ToldosCofre from "../pages/toldos/toldos-cofre/page";
import ToldosExtensibles from "../pages/toldos/toldos-extensibles/page";
import Mosquiteras from "../pages/mosquiteras/page";
import MosequiterasEnrollables from "../pages/mosquiteras/mosquiteras-enrollables/page";
import MosequiterasCorrederas from "../pages/mosquiteras/mosquiteras-correderas/page";
import MosequiterasFijas from "../pages/mosquiteras/mosquiteras-fijas/page";
import ReparacionMosquiteras from "../pages/mosquiteras/reparacion-mosquiteras/page";
import Zonas from "../pages/zonas/page";
import Contacto from "../pages/contacto/page";
import PoliticaCookies from "../pages/politica-cookies/page";
import AvisoLegal from "../pages/aviso-legal/page";
import PoliticaPrivacidad from "../pages/politica-privacidad/page";
import ReparacionPersianas from "../pages/persianas/reparacion-persianas-malaga/page";
import MotorPersianas from "../pages/persianas/motor-persianas/page";
import ToldosMotorizados from "../pages/toldos/toldos-motorizados/page";
import ToldosVeranda from "../pages/toldos/toldos-veranda/page";
import ToldosBalcón from "../pages/toldos/toldos-balcon/page";
import InstalacionToldos from "../pages/toldos/instalacion-toldos/page";
import ReparacionToldos from "../pages/toldos/reparacion-toldos/page";
import PreciosToldos from "../pages/toldos/precios-toldos/page";
import ToldosMalaga from "../pages/toldos/malaga/page";
import ToldosMarbella from "../pages/toldos/marbella/page";
import ToldosMijas from "../pages/toldos/mijas/page";
import ToldosFuengirola from "../pages/toldos/fuengirola/page";
import ToldosEstepona from "../pages/toldos/estepona/page";
import ToldosTorremolinos from "../pages/toldos/torremolinos/page";
import ToldosBenalmadena from "../pages/toldos/benalmadena/page";
import ToldosVelezMalaga from "../pages/toldos/velez-malaga/page";
import ToldosNerja from "../pages/toldos/nerja/page";
import ToldosAntequera from "../pages/toldos/antequera/page";
import PersianasMarbella from "../pages/persianas/marbella/page";
import PersianasMalaga from "../pages/persianas/malaga/page";
import PersianasMijas from "../pages/persianas/mijas/page";
import PersianasFuengirola from "../pages/persianas/fuengirola/page";
import PersianasEstepona from "../pages/persianas/estepona/page";
import PersianasTorremolinos from "../pages/persianas/torremolinos/page";
import PersianasBenalmadena from "../pages/persianas/benalmadena/page";
import PersianasVelezMalaga from "../pages/persianas/velez-malaga/page";
import PersianasRinconVictoria from "../pages/persianas/rincon-de-la-victoria/page";
import PersianasSanPedro from "../pages/persianas/san-pedro-de-alcantara/page";
import PersianasAntequera from "../pages/persianas/antequera/page";
import PersianasRonda from "../pages/persianas/ronda/page";
import PersianasNerja from "../pages/persianas/nerja/page";
import PersianasBenahavis from "../pages/persianas/benahavis/page";
import PersianasAlhaurin from "../pages/persianas/alhaurin-de-la-torre/page";
import PersianasAlhaurinGrande from "../pages/persianas/alhaurin-el-grande/page";
import PersianasCoin from "../pages/persianas/coin/page";
import PersianasCartama from "../pages/persianas/cartama/page";
import PersianasAlora from "../pages/persianas/alora/page";
import PannePersianaPage from "../pages/persianas/pannes/page";
import StubPage from "../components/feature/StubPage";
import MosquiterasMalaga from "../pages/mosquiteras/malaga/page";
import MosquiterasMarbella from "../pages/mosquiteras/marbella/page";
import MosquiterasMijas from "../pages/mosquiteras/mijas/page";
import MosquiterasFuengirola from "../pages/mosquiteras/fuengirola/page";
import MosquiterasEstepona from "../pages/mosquiteras/estepona/page";
import MosquiterasTorremolinos from "../pages/mosquiteras/torremolinos/page";
import MosquiterasBenalmadena from "../pages/mosquiteras/benalmadena/page";
import MosquiterasVelezMalaga from "../pages/mosquiteras/velez-malaga/page";
import MosquiterasNerja from "../pages/mosquiteras/nerja/page";
import MosquiterasAntequera from "../pages/mosquiteras/antequera/page";
import ZoneMalaga from "../pages/zonas/malaga/page";
import ZoneMarbella from "../pages/zonas/marbella/page";
import ZoneFuengirola from "../pages/zonas/fuengirola/page";
import ZoneTorremolinos from "../pages/zonas/torremolinos/page";
import ZoneBenalmadena from "../pages/zonas/benalmadena/page";
import ZoneMijas from "../pages/zonas/mijas/page";
import ZoneEstepona from "../pages/zonas/estepona/page";
import ZoneAxarquia from "../pages/zonas/axarquia/page";
import ZoneGuadalhorce from "../pages/zonas/valle-del-guadalhorce/page";
import SerraniaRonda from "../pages/zonas/serrania-de-ronda/page";
import ZoneVelezMalaga from "../pages/zonas/velez-malaga/page";
import ZoneRinconVictoria from "../pages/zonas/rincon-de-la-victoria/page";
import ZoneBenahavis from "../pages/zonas/benahavis/page";
import ZoneSanPedro from "../pages/zonas/san-pedro-de-alcantara/page";
import Presupuesto from "../pages/presupuesto/page";
import SobreNosotros from "../pages/sobre-nosotros/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/persianas", element: <Persianas /> },
  { path: "/persianas/malaga", element: <PersianasMalaga /> },
  { path: "/persianas/marbella", element: <PersianasMarbella /> },
  { path: "/persianas/mijas", element: <PersianasMijas /> },
  { path: "/persianas/fuengirola", element: <PersianasFuengirola /> },
  { path: "/persianas/estepona", element: <PersianasEstepona /> },
  { path: "/persianas/torremolinos", element: <PersianasTorremolinos /> },
  { path: "/persianas/benalmadena", element: <PersianasBenalmadena /> },
  { path: "/persianas/velez-malaga", element: <PersianasVelezMalaga /> },
  { path: "/persianas/rincon-de-la-victoria", element: <PersianasRinconVictoria /> },
  { path: "/persianas/san-pedro-de-alcantara", element: <PersianasSanPedro /> },
  { path: "/persianas/antequera", element: <PersianasAntequera /> },
  { path: "/persianas/ronda", element: <PersianasRonda /> },
  { path: "/persianas/nerja", element: <PersianasNerja /> },
  { path: "/persianas/benahavis", element: <PersianasBenahavis /> },
  { path: "/persianas/alhaurin-de-la-torre", element: <PersianasAlhaurin /> },
  { path: "/persianas/alhaurin-el-grande", element: <PersianasAlhaurinGrande /> },
  { path: "/persianas/coin", element: <PersianasCoin /> },
  { path: "/persianas/cartama", element: <PersianasCartama /> },
  { path: "/persianas/alora", element: <PersianasAlora /> },
  { path: "/persianas/reparacion-persianas-malaga", element: <ReparacionPersianas /> },
  { path: "/persianas/motor-persianas", element: <MotorPersianas /> },
  { path: "/persianas/persianas-electricas", element: <PersianasElectricas /> },
  { path: "/persianas/cambiar-cinta-persiana", element: <CambiarCinta /> },
  { path: "/persianas/persianas-aluminio", element: <PersianasAluminio /> },
  { path: "/persianas/persianas-pvc", element: <PersianasPVC /> },
  { path: "/persianas/precios-persianas", element: <PreciosPersianas /> },
  { path: "/persianas/pannes/:slug", element: <PannePersianaPage /> },
  { path: "/toldos", element: <Toldos /> },
  { path: "/toldos/toldos-cofre", element: <ToldosCofre /> },
  { path: "/toldos/toldos-extensibles", element: <ToldosExtensibles /> },
  { path: "/toldos/toldos-motorizados", element: <ToldosMotorizados /> },
  { path: "/toldos/toldos-veranda", element: <ToldosVeranda /> },
  { path: "/toldos/toldos-balcon", element: <ToldosBalcón /> },
  { path: "/toldos/instalacion-toldos", element: <InstalacionToldos /> },
  { path: "/toldos/reparacion-toldos", element: <ReparacionToldos /> },
  { path: "/toldos/precios-toldos", element: <PreciosToldos /> },
  { path: "/toldos/malaga", element: <ToldosMalaga /> },
  { path: "/toldos/marbella", element: <ToldosMarbella /> },
  { path: "/toldos/mijas", element: <ToldosMijas /> },
  { path: "/toldos/fuengirola", element: <ToldosFuengirola /> },
  { path: "/toldos/estepona", element: <ToldosEstepona /> },
  { path: "/toldos/torremolinos", element: <ToldosTorremolinos /> },
  { path: "/toldos/benalmadena", element: <ToldosBenalmadena /> },
  { path: "/toldos/velez-malaga", element: <ToldosVelezMalaga /> },
  { path: "/toldos/nerja", element: <ToldosNerja /> },
  { path: "/toldos/antequera", element: <ToldosAntequera /> },
  { path: "/mosquiteras", element: <Mosquiteras /> },
  { path: "/mosquiteras/mosquiteras-enrollables", element: <MosequiterasEnrollables /> },
  { path: "/mosquiteras/mosquiteras-correderas", element: <MosequiterasCorrederas /> },
  { path: "/mosquiteras/mosquiteras-fijas", element: <MosequiterasFijas /> },
  { path: "/mosquiteras/reparacion-mosquiteras", element: <ReparacionMosquiteras /> },
  { path: "/mosquiteras/malaga", element: <MosquiterasMalaga /> },
  { path: "/mosquiteras/marbella", element: <MosquiterasMarbella /> },
  { path: "/mosquiteras/mijas", element: <MosquiterasMijas /> },
  { path: "/mosquiteras/fuengirola", element: <MosquiterasFuengirola /> },
  { path: "/mosquiteras/estepona", element: <MosquiterasEstepona /> },
  { path: "/mosquiteras/torremolinos", element: <MosquiterasTorremolinos /> },
  { path: "/mosquiteras/benalmadena", element: <MosquiterasBenalmadena /> },
  { path: "/mosquiteras/velez-malaga", element: <MosquiterasVelezMalaga /> },
  { path: "/mosquiteras/nerja", element: <MosquiterasNerja /> },
  { path: "/mosquiteras/antequera", element: <MosquiterasAntequera /> },
  { path: "/zonas", element: <Zonas /> },
  { path: "/zonas/malaga", element: <ZoneMalaga /> },
  { path: "/zonas/marbella", element: <ZoneMarbella /> },
  { path: "/zonas/fuengirola", element: <ZoneFuengirola /> },
  { path: "/zonas/torremolinos", element: <ZoneTorremolinos /> },
  { path: "/zonas/benalmadena", element: <ZoneBenalmadena /> },
  { path: "/zonas/mijas", element: <ZoneMijas /> },
  { path: "/zonas/estepona", element: <ZoneEstepona /> },
  { path: "/zonas/axarquia", element: <ZoneAxarquia /> },
  { path: "/zonas/valle-del-guadalhorce", element: <ZoneGuadalhorce /> },
  { path: "/zonas/serrania-de-ronda", element: <SerraniaRonda /> },
  { path: "/zonas/velez-malaga", element: <ZoneVelezMalaga /> },
  { path: "/zonas/rincon-de-la-victoria", element: <ZoneRinconVictoria /> },
  { path: "/zonas/benahavis", element: <ZoneBenahavis /> },
  { path: "/zonas/san-pedro-de-alcantara", element: <ZoneSanPedro /> },
  { path: "/contacto", element: <Contacto /> },
  { path: "/presupuesto", element: <Presupuesto /> },
  { path: "/sobre-nosotros", element: <SobreNosotros /> },
  { path: "/politica-cookies", element: <PoliticaCookies /> },
  { path: "/aviso-legal", element: <AvisoLegal /> },
  { path: "/politica-privacidad", element: <PoliticaPrivacidad /> },
  { path: "/gracias", element: <Gracias /> },
  { path: "/404", element: <NotFound /> },
  { path: "*", element: <NotFound /> },
];

export default routes;